import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const transferContractOut = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumber',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumber'
            },
            filteredValue: filteredInfo.contractNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同名称',
            dataIndex: 'contractName',
            key: 'contractName',
            scopedSlots: {
                customRender: 'contractName',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同类型',
            dataIndex: 'projectType',
            key: 'projectType'
        },

        {
            title: '合同分类',
            dataIndex: 'contractType',
            key: 'contractType',
            scopedSlots: {
                customRender: 'contractType'
            },
        },
        {
            title: '合同金额',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同拟定时间',
            dataIndex: 'contractDraftingDate',
            key: 'contractDraftingDate',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '付款方销售',
            dataIndex: 'sales.name',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '付款方客户联系人',
            dataIndex: 'customerContacts.contactName',
            key: 'customerContactsName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.customerContactsName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '收款方销售',
            dataIndex: 'incomingContacts.salesName',
            key: 'incomingContactSalesName'
        },
        {
            title: '收款方客户联系人',
            dataIndex: 'incomingContacts.contactName',
            key: 'incomingContactsName',
            // scopedSlots: {
            //     filterDropdown: 'filterDropdown',
            //     filterIcon: 'filterIcon',
            //     filtered: true,
            // },
            // filteredValue: filteredInfo.customerContactsName || [],
            // sorter: true,
            // sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
